// Cloudflare R2 객체 URL/메타 유틸.
//
// R2 bucket 의 public custom domain 이 toy-ple.net 으로 연결되어 있고,
// 객체 key 는 `lansly/projects/{project_id}/chat/{message_id}/{file}` 형태로 저장된다.
// 다운로드 URL = `https://{R2_PUBLIC_BASE_URL}/{key}`.
//
// 빌드 시점 환경변수 REACT_APP_R2_PUBLIC_BASE_URL 로 override 가능 (예: dev/staging 분기).

const DEFAULT_R2_BASE = 'https://toy-ple.net';

export function r2PublicBase() {
  return (
    (typeof process !== 'undefined' &&
      process.env &&
      process.env.REACT_APP_R2_PUBLIC_BASE_URL) ||
    DEFAULT_R2_BASE
  ).replace(/\/+$/, '');
}

export function r2Url(key) {
  if (!key) return '';
  return `${r2PublicBase()}/${String(key).replace(/^\/+/, '')}`;
}

// 한 메시지에 묶인 첨부를 3 군(이미지·동영상·기타 파일) 으로 나눠 렌더링용으로 정렬
export function partitionAttachments(attachments) {
  const list = Array.isArray(attachments) ? attachments : [];
  const images = [];
  const videos = [];
  const files = [];
  list.forEach((a) => {
    const t = (a?.type || '').toLowerCase();
    if (t.startsWith('image/')) images.push(a);
    else if (t.startsWith('video/')) videos.push(a);
    else files.push(a);
  });
  return { images, videos, files };
}

export function formatBytes(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v <= 0) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let size = v;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i += 1;
  }
  return `${size.toFixed(size < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

// 확장자/MIME 기반 카테고리 — 카드 아이콘·테두리 색 결정용
export function fileCategory(file) {
  const t = (file?.type || '').toLowerCase();
  const name = (file?.name || '').toLowerCase();
  const ext = name.includes('.') ? name.split('.').pop() : '';

  if (t === 'application/pdf' || ext === 'pdf') return 'pdf';
  if (
    t.includes('wordprocessingml') ||
    t === 'application/msword' ||
    ext === 'doc' ||
    ext === 'docx'
  )
    return 'word';
  if (
    t.includes('spreadsheetml') ||
    t === 'application/vnd.ms-excel' ||
    ext === 'xls' ||
    ext === 'xlsx' ||
    ext === 'csv'
  )
    return 'excel';
  if (
    t.includes('presentationml') ||
    t === 'application/vnd.ms-powerpoint' ||
    ext === 'ppt' ||
    ext === 'pptx'
  )
    return 'ppt';
  if (
    t === 'application/zip' ||
    t === 'application/x-zip-compressed' ||
    ext === 'zip' ||
    ext === 'rar' ||
    ext === '7z'
  )
    return 'zip';
  if (t.startsWith('text/') || ext === 'txt' || ext === 'md') return 'text';
  return 'file';
}

